import _toConsumableArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useUncontrolled, useDidUpdate } from '@mantine/hooks';
import { useFloating, size, offset, shift, limitShift, flip, inline, arrow } from '@floating-ui/react';
import { useFloatingAutoUpdate } from '../Floating/use-floating-auto-update.js';
function getPopoverMiddlewares(options) {
  var middlewares = [offset(options.offset)];
  if (options.middlewares.shift) {
    middlewares.push(shift({
      limiter: limitShift()
    }));
  }
  if (options.middlewares.flip) {
    middlewares.push(flip());
  }
  if (options.middlewares.inline) {
    middlewares.push(inline());
  }
  middlewares.push(arrow({
    element: options.arrowRef,
    padding: options.arrowOffset
  }));
  return middlewares;
}
function usePopover(options) {
  var _useUncontrolled = useUncontrolled({
      value: options.opened,
      defaultValue: options.defaultOpened,
      finalValue: false,
      onChange: options.onChange
    }),
    _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
    _opened = _useUncontrolled2[0],
    setOpened = _useUncontrolled2[1];
  var onClose = function onClose() {
    var _a;
    (_a = options.onClose) == null ? void 0 : _a.call(options);
    setOpened(false);
  };
  var onToggle = function onToggle() {
    var _a, _b;
    if (_opened) {
      (_a = options.onClose) == null ? void 0 : _a.call(options);
      setOpened(false);
    } else {
      (_b = options.onOpen) == null ? void 0 : _b.call(options);
      setOpened(true);
    }
  };
  var floating = useFloating({
    placement: options.position,
    middleware: [].concat(_toConsumableArray(getPopoverMiddlewares(options)), _toConsumableArray(options.width === "target" ? [size({
      apply: function apply(_ref) {
        var rects = _ref.rects;
        var _a, _b;
        Object.assign((_b = (_a = floating.refs.floating.current) == null ? void 0 : _a.style) != null ? _b : {}, {
          width: "".concat(rects.reference.width, "px")
        });
      }
    })] : []))
  });
  useFloatingAutoUpdate({
    opened: options.opened,
    positionDependencies: options.positionDependencies,
    floating: floating
  });
  useDidUpdate(function () {
    var _a;
    (_a = options.onPositionChange) == null ? void 0 : _a.call(options, floating.placement);
  }, [floating.placement]);
  return {
    floating: floating,
    controlled: typeof options.opened === "boolean",
    opened: _opened,
    onClose: onClose,
    onToggle: onToggle
  };
}
export { usePopover };